export default __webpack_public_path__ + "static/media/handwash.a449b266.jpg";